import { render, staticRenderFns } from "./UserCheckCnpj.vue?vue&type=template&id=1b15ffcb&"
import script from "./UserCheckCnpj.vue?vue&type=script&lang=js&"
export * from "./UserCheckCnpj.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports